// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.add-with-autocompletion {
  display: flex;
  align-items: center;
}
.add-with-autocompletion__input {
  background-color: var(--color-input-background);
  color: var(--color-content-base);
  box-shadow: 0 0 0 1px var(--color-border-base), 0px -1px 1px var(--color-border-base);
  line-height: 32px;
  font-size: 14px;
  font-weight: 400;
  border-radius: 4px;
  border: none;
  height: 32px;
  padding: 0 5px;
}
.add-with-autocompletion__input--disabled {
  opacity: 0.5;
}
.add-with-autocompletion__input--plain {
  box-shadow: none;
}
.add-with-autocompletion__input--hide-arrows::-webkit-outer-spin-button,
.add-with-autocompletion__input--hide-arrows::-webkit-inner-spin-button {
  -webkit-appearance: none;
  /* Chrome & Safari */
}
.add-with-autocompletion__input--hide-arrows[type=number] {
  -moz-appearance: textfield;
  /* Firefox */
}
.add-with-autocompletion__input--error {
  box-shadow: 0 0 0 1px var(--color-error-shadow-base), 0px -1px 1px var(--color-error-shadow-base);
  background-color: var(--color-error-background-base);
}
.add-with-autocompletion__input--variant-small {
  height: 24px;
  line-height: 24px;
  border-radius: 4px;
}
.add-with-autocompletion__input--variant-medium {
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
}
.add-with-autocompletion__input--variant-large {
  height: 40px;
  line-height: 40px;
  border-radius: 4px;
}
.add-with-autocompletion__input--focused,
.add-with-autocompletion__input:focus {
  outline-offset: 2px;
  outline: 2px solid var(--color-outline-base);
}
.add-with-autocompletion__plus-icon {
  color: var(--color-accent-content-base);
}
.add-with-autocompletion__plus-icon:hover {
  color: var(--color-accent-content-base);
}
.react-autosuggest__container {
  position: relative;
  display: inline-block;
  line-height: 22px;
}
.react-autosuggest__input {
  width: 182px;
}
.react-autosuggest__input:focus {
  outline: none;
}
.react-autosuggest__container--open .react-autosuggest__input {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.react-autosuggest__container--open .react-autosuggest__suggestions-container {
  position: absolute;
  top: 22px;
  width: 182px;
  margin: 0;
  padding: 0;
  list-style-type: none;
  background-color: var(--color-popover-background);
  z-index: 2;
  max-height: 250px;
  border: 1px solid var(--color-border-base);
  overflow: auto;
}
.react-autosuggest__suggestions-list {
  margin-bottom: 0;
}
.react-autosuggest__suggestion {
  cursor: pointer;
  word-break: break-all;
  padding: 0 5px;
}
.react-autosuggest__suggestion--highlighted {
  background: var(--color-neutral-background-hover);
}
.react-autosuggest__suggestion:not(:first-child) {
  border-top: 1px solid var(--color-border-subdued);
}
.react-autosuggest__suggestion--focused {
  background-color: var(--color-accent-subtle-background-base);
  color: var(--color-accent-content-contrast);
}
.react-autosuggest__suggestion--focused .highlight {
  color: var(--color-accent-content-base);
}
.suggestion-content {
  display: flex;
  align-items: center;
  background-repeat: no-repeat;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/tags/ui/AddWithAutocompletion.less","webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/input.less","webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/misc.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AAPA;EAGE,aAAA;EACA,mBAAA;AAOF;AALE;ECLA,+CAAA;EACA,gCAAA;EACA,qFAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EAGE,cAAA;ADWJ;ACRE;EACE,YAAA;ADUJ;ACPE;EACE,gBAAA;ADSJ;ACLI;;EAEE,wBAAA;EDOJ,oBAAoB;AACtB;ACLI;EACE,0BAAA;EDOJ,YAAY;AACd;ACJE;EACE,iGAAA;EACA,oDAAA;ADMJ;ACHE;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;ADKJ;ACFE;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;ADIJ;ACDE;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;ADGJ;ACAE;;EC1DA,mBAAA;EACA,4CAAA;AF8DF;AApDE;EACE,uCAAA;AAsDJ;AApDI;EACE,uCAAA;AAsDN;AA7CE;EACE,kBAAA;EACA,qBAAA;EACA,iBAAA;AA+CJ;AA5CE;EACE,YAAA;AA8CJ;AA3CE;EACE,aAAA;AA6CJ;AA1CE;EACE,4BAAA;EACA,6BAAA;AA4CJ;AAzCE;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,iDAAA;EACA,UAAA;EACA,iBAAA;EACA,0CAAA;EACA,cAAA;AA2CJ;AAxCE;EACE,gBAAA;AA0CJ;AAvCE;EACE,eAAA;EACA,qBAAA;EACA,cAAA;AAyCJ;AAvCI;EACE,iDAAA;AAyCN;AArCE;EACE,iDAAA;AAuCJ;AApCE;EACE,4DAAA;EACA,2CAAA;AAsCJ;AAlCE;EACE,uCAAA;AAoCJ;AAhCA;EACE,aAAA;EACA,mBAAA;EACA,4BAAA;AAkCF","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import '~venus';\n\n.add-with-autocompletion {\n  @link-color: var(--color-accent-content-base);\n\n  display: flex;\n  align-items: center;\n\n  &__input {\n    .neptune-input();\n  }\n\n  &__plus-icon {\n    color: @link-color;\n\n    &:hover {\n      color: @link-color;\n    }\n  }\n}\n\n.react-autosuggest {\n  @add-with-autocompletion-width: 182px;\n  @add-with-autocompletion-height: 22px;\n\n  &__container {\n    position: relative;\n    display: inline-block;\n    line-height: @add-with-autocompletion-height;\n  }\n\n  &__input {\n    width: @add-with-autocompletion-width;\n  }\n\n  &__input:focus {\n    outline: none;\n  }\n\n  &__container--open &__input {\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n\n  &__container--open &__suggestions-container {\n    position: absolute;\n    top: @add-with-autocompletion-height;\n    width: @add-with-autocompletion-width;\n    margin: 0;\n    padding: 0;\n    list-style-type: none;\n    background-color: var(--color-popover-background);\n    z-index: 2;\n    max-height: 250px;\n    border: 1px solid var(--color-border-base);\n    overflow: auto;\n  }\n\n  &__suggestions-list {\n    margin-bottom: 0;\n  }\n\n  &__suggestion {\n    cursor: pointer;\n    word-break: break-all;\n    padding: 0 5px;\n\n    &--highlighted {\n      background: var(--color-neutral-background-hover);\n    }\n  }\n\n  &__suggestion:not(:first-child) {\n    border-top: 1px solid var(--color-border-subdued);\n  }\n\n  &__suggestion--focused {\n    background-color: var(--color-accent-subtle-background-base);\n    color: var(--color-accent-content-contrast);\n  }\n\n\n  &__suggestion--focused .highlight {\n    color: var(--color-accent-content-base);\n  }\n}\n\n.suggestion-content {\n  display: flex;\n  align-items: center;\n  background-repeat: no-repeat;\n}\n","@import \"./../variables.less\";\n\n.neptune-input(@with-padding: true) {\n  background-color: var(--color-input-background);\n  color: var(--color-content-base);\n  box-shadow: @input-box-shadow;\n  line-height: 32px;\n  font-size: @fontSize-sm;\n  font-weight: @fontWeight-regular;\n  border-radius: @input-border-radius;\n  border: none;\n  height: 32px;\n\n  & when (@with-padding = true) {\n    padding: 0 5px;\n  }\n\n  &--disabled {\n    opacity: 0.5;\n  }\n\n  &--plain {\n    box-shadow: none;\n  }\n\n  &--hide-arrows {\n    &::-webkit-outer-spin-button,\n    &::-webkit-inner-spin-button {\n      -webkit-appearance: none; /* Chrome & Safari */\n    }\n\n    &[type=number] {\n      -moz-appearance: textfield; /* Firefox */\n    }\n  }\n\n  &--error {\n    box-shadow: @input-box-shadow-error;\n    background-color: @input-bg-error;\n  }\n\n  &--variant-small {\n    height: @layoutUnit-lg;\n    line-height: @layoutUnit-lg;\n    border-radius: 4px;\n  }\n\n  &--variant-medium {\n    height: @layoutUnit-xl;\n    line-height: @layoutUnit-xl;\n    border-radius: 4px;\n  }\n\n  &--variant-large {\n    height: @layoutUnit-xxl;\n    line-height: @layoutUnit-xxl;\n    border-radius: 4px;\n  }\n\n  &--focused,\n  &:focus {\n    .n-outline();\n  }\n}\n\n.neptune-input-select() {\n  .neptune-input(@with-padding: false);\n\n  cursor: pointer;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n\n  user-select: none;\n\n  padding: 6px 8px;\n\n  &[data-placeholder] {\n    color: var(--color-content-secondary);\n  }\n\n  &__icon {\n    color: var(--color-content-secondary);\n  }\n}\n",".n-outline() {\n  outline-offset: 2px;\n  outline: 2px solid var(--color-outline-base);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
